<template>
  <div v-if="customer" class="py-6">
    <div class="flex justify-between items-center mb-6">
      <div class="">
        <h4 class="text-lg mr-4 leading-none font-semibold opacity-80">
          {{ $t('general.sales') }}
        </h4>
      </div>

      <div class="flex-shrink-0 ml-12">
        <o-button v-if="!customer.isArchived" variant="primary" flat @click="handleCreateOrder">
          {{ $t('order.new') }}
        </o-button>
      </div>
    </div>
    <div class="flex items-center space-x-2 mb-10">
      <o-statistic
        :title="$t('general.sales')"
        :value="customer.stats.orderCount"
        icon="sale"
        class="w-1/4 max-w-50"
      />
      <o-statistic
        :title="$t('components.customer.profile.sales.revenue')"
        :value="$currency.format(customer.stats.orderRevenue)"
        icon="currency"
        class="w-1/4 max-w-50"
      />
      <o-statistic
        v-if="customer.stats.orderRevenue && customer.stats.orderCount"
        :title="$t('customer.averageValue')"
        :value="$currency.format(customer.stats.orderRevenue / customer.stats.orderCount)"
        icon="chart"
        class="w-1/4 max-w-50"
      />
    </div>
    <!--<div v-for="(group, key) in sales" :key="key" class="mb-8">
      <p class="text-xs mb-3 tracking-wider opacity-80 uppercase">
        {{ key }}
      </p>
      <div class="flex flex-col divide-y overflow-hidden p-2 md:p-2 items-center h-full bg-white dark:bg-gray-800/20 dark:border dark:border-gray-800 shadow-lg rounded-2xl mb-4">
        <sale
          v-for="sale in group"
          :key="sale.idOrder"
          :sale="sale"
          class="w-full"
        />
      </div>
    </div>-->

    <o-pager
      :button="$t('general.loadMore')"
      :empty="$t('components.customer.profile.sales.empty')"
      :list="sales"
      class="mt-4"
    >
      <template #default="{data}">
        <div v-for="(group, key) in split(data)" :key="key" class="mb-8">
          <p class="text-xs mb-3 tracking-wider opacity-80 uppercase">
            {{ key }}
          </p>
          <div class="flex flex-col divide-y overflow-hidden p-2 md:p-2 items-center h-full dark:bg-gray-800/20 dark:border dark:border-gray-800 shadow-lg rounded-2xl mb-4">
            <sale
              v-for="sale in group"
              :key="sale.idOrder"
              :sale="sale"
              class="w-full"
            />
          </div>
        </div>
      </template>
    </o-pager>

    <create-order-dialog
      ref="createOrderDialog"
    />
  </div>
</template>

<script setup lang="ts">
import { EndlessListPager } from '@/_api/lib/pager'

import Sale from './sale.vue'
import CreateOrderDialog from '@/components/order/actions/CreateOrder.vue'

import { OStatistic, OPager } from '@/components/elements'

interface Props {
  customer?: Record<string, any> | null
}

const props = withDefaults(defineProps<Props>(), {
  customer: null,
})

const { $api, $bus, $date } = useNuxtApp()

const customerId = computed(() => props.customer?.idCustomer || props.customer?.id)

const createOrderDialog = ref<any>()

const selected = ref<any[]>([])
const sales = reactive(new EndlessListPager((page: number) => $api.customer.orders(String(customerId.value), { page })))

const handleCreateOrder = () => {
  const customer = props.customer

  const data = {
    customer,
  }

  createOrderDialog.value.open(data)
}

const split = (data: any[]) => {
  return data.reduce((acc: Record<string, any[]>, cur: any) => {
    const date = ($date as any).format(cur.date * 1000, 'MMMM yyyy')
    acc[date] = [...acc[date] || [], cur]
    return acc
  }, {})
}

// created
const uid = getCurrentInstance()?.uid

onMounted(() => {
  sales.load()

  $bus.on.all('Order', uid, (_order: any) => {
    sales.reload()
  })
})

onBeforeUnmount(() => {
  $bus.off.all(uid)
})
</script>
